import React, { useRef } from 'react'

import {
  BlankSlate,
  Box,
  InfiniteScroll,
  Skeleton,
  Spinner,
} from '@factorialco/deprecated-design-system'
import {
  ReviewProcessCustomTemplateFragment,
  ReviewProcessPredefinedTemplateFragment,
} from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import { TemplateCard } from './TemplateCard'

export const TemplateListContent: React.FC<{
  loading: boolean
  templates: ReviewProcessPredefinedTemplateFragment[] | ReviewProcessCustomTemplateFragment[]
  templateId?: number
  setTemplateId: (id: number) => void
  hasMore: boolean
  fetchMore: () => void
}> = ({ loading, templates, templateId, setTemplateId, hasMore, fetchMore }) => {
  const scrollContainerRef = useRef<HTMLDivElement>(null)
  if (loading) return <Skeleton isLoading height="full" />

  const loader = (
    <Box key="loader" padding="s16" alignItems="center" justifyContent="center">
      <Spinner />
    </Box>
  )

  if (templates.length === 0)
    return (
      <BlankSlate
        illustration="alert"
        title={i18n.t('performance_process.reviews.templates.empty_state.title')}
        description={i18n.t('performance_process.reviews.templates.empty_state.description')}
      />
    )

  return (
    <Box ref={scrollContainerRef} data-scroll-container maxHeight={'s600'} overflowY="auto">
      <InfiniteScroll
        scrollContainerRef={scrollContainerRef}
        threshold={50}
        loadMore={fetchMore}
        hasMore={hasMore}
        initialLoad={loading}
        loader={loader}
      >
        <Box gap="s24">
          {templates.map((template) => (
            <TemplateCard
              key={template.id}
              template={template}
              selectedTemplateId={templateId}
              onDataChanged={() => setTemplateId(template.id)}
            />
          ))}
        </Box>
      </InfiniteScroll>
    </Box>
  )
}
